import React from 'react'
import { AppCardTitle, AppCrudTable, AppResultsSkeleton } from '@components'
import { useTableData } from 'Pages/Admin/GroupedExports/@hooks'
import { isLoadingTable } from 'Pages/Admin/GroupedExports/@signals'
import { createdColumn, exportedColumn, filenameColumn, infoColumn, timestampExportColumn, userColumn } from 'Pages/Admin/GroupedExports/Table/@columns'
import GroupedExportsTableToolbar from 'Pages/Admin/GroupedExports/Table/Toolbar'


export default function GroupedExportsTable({ isExtra }) {

	const data = useTableData(isExtra)

	if (isLoadingTable.value) return <AppResultsSkeleton/>

	return <AppCrudTable
		title={<AppCardTitle icon="layer-group" title="Export Groups"/>}
		options={{
			selectableRows: 'multiple',
			customToolbarSelect: (selectedData, setSelectedRows) => <GroupedExportsTableToolbar
				selectedData={selectedData}
				setSelectedRows={setSelectedRows}/>,
		}}
		columns={[ userColumn(), filenameColumn(), ...createdColumn(), ...timestampExportColumn(), ...exportedColumn(), infoColumn() ]}
		data={data}
	/>
}